import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

import Popover from '../popover';

const MobileDropdownOptions = ({
  options,
  hasCancelSaveActions,
  values,
  onSelect,
  onClose,
  onCancel,
  onSave,
}) => {
  const t = useTranslation();

  return (
    <Popover onClose={onClose} className="P-popover-no-content-padding">
      <div className="mobile-dropdown-options">
        {options.map((item) => {
          const isItemCurrentlySelected = values.includes(item.value);

          return item.countryAlias
            ? (
              <div
                onClick={(e) => onSelect(e, item)}
                className={`mobile-dropdown-option ${isItemCurrentlySelected ? 'mobile-dropdown-option-active' : ''}`}
                key={item.value}
              >
                <span
                  className={`flag icon-${item.countryAlias?.toLowerCase()} flag`}
                />
                <p>
                  {item.name}
                </p>
                {isItemCurrentlySelected && <i className="global-icon icon-regular-checkmark" />}
              </div>
            ) : (
              <p
                key={item.value}
                className={`mobile-dropdown-option ${isItemCurrentlySelected ? 'mobile-dropdown-option-active' : ''}`}
                onClick={(e) => onSelect(e, item)}
              >
                {item.name}
                {isItemCurrentlySelected && <i className="global-icon icon-regular-checkmark mobile-dropdown-option-checkmark-icon" />}
              </p>
            );
        })}
      </div>
      {hasCancelSaveActions && (
        <div className="mobile-dropdown-options-actions">
          <button
            type="button"
            className="mobile-dropdown-cancel"
            onClick={onCancel}
          >
            {t('Cancel')}
          </button>

          <button
            type="button"
            className="mobile-dropdown-save"
            onClick={onSave}
          >
            {t('Save')}
          </button>
        </div>
      )}
    </Popover>
  );
};

MobileDropdownOptions.propTypes = {
  hasCancelSaveActions: PropTypes.bool,
  options: PropTypes.array,
  values: PropTypes.array,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

export default MobileDropdownOptions;
